import styled, { css } from "styled-components";
import { breakpoints } from "styles/grid";
import Icon from "components/global/Icon";
import Heading from "components/typography/Heading";
import Link from "components/layout/Link";
import Block from "components/layout/Block";

// ** SVG Static Imports
import { ReactComponent as LightAngleRight } from "resources/icons/light/angle-right.svg";

const Wrapper = styled.div`
	${({ padded, noPadding }) =>
		!noPadding &&
		padded &&
		css`
			padding: 0.5rem 1rem 0;
			@media (max-width: ${breakpoints.phone - 1}px) {
				padding: ${({ nopad }) => (nopad ? 0 : "0.5rem 1rem 0")};
			}
		`}

	${({ headerGrid }) =>
		headerGrid &&
		css`
			padding-bottom: 0.5rem;
			padding-left: 0;
			padding-right: 0;
			border-bottom: var(--size-grid-small) solid
				${({ theme: { colors } }) => colors.buttonsDefaultGrey};

			@media (max-width: ${breakpoints.phone - 1}px) {
				padding-bottom: 0.5rem;
				padding-left: 0;
				padding-right: 0;
			}
		`}
`;

const StyledIcon = styled((props) => <Icon {...props} />)`
	font-size: 1.25rem;
	line-height: 1.25rem;
	svg {
		color: ${({ theme: { colors } }) => colors.textMuted};
		position: relative;
		top: 1px;
	}
	vertical-align: middle;
`;

const StyledLink = styled(Link)`
	display: inline-block;
	color: ${({ theme: { colors } }) => colors.black} !important;

	${({ toRight }) =>
		toRight &&
		css`
			float: right;
		`}

	${StyledIcon} {
		opacity: 1;
		/* transition: opacity 0.15s; */
	}

	/* &:focus,
	&:hover {
		${StyledIcon} {
			opacity: 1;
		}
	} */
`;

export default ({
	children,
	type,
	to,
	noPadding,
	headerGrid,
	additional,
	withoutIcon = false,
	onClick,
	size,
}) => (
	<Wrapper
		padded={type === "h2"}
		noPadding={noPadding}
		headerGrid={headerGrid}
	>
		{to ? (
			<Block flex>
				<Block flex alignCenter fullWidth full>
					<StyledLink to={to} onClick={onClick}>
						<Heading type={type} bold inline size={size}>
							{children}
						</Heading>
					</StyledLink>
				</Block>

				<Block flex justifyEnd alignCenter>
					<Block mr={2}>{additional}</Block>
					{!withoutIcon ? (
						<StyledLink to={to} toRight onClick={onClick}>
							<StyledIcon svgIconComponent={LightAngleRight} />
						</StyledLink>
					) : null}
				</Block>
			</Block>
		) : (
			<Heading type={type} bold inline size={size}>
				{children}
			</Heading>
		)}
	</Wrapper>
);
